/**
 * List of Arizona teams for filtering season averages
 * Source: AzState.xlsx
 *
 * Note: Different meets may use different naming conventions for the same team:
 * - "Biltmore" vs "Biltmore AZ"
 * - "Aspire JrSunDevils" vs "Aspire AZ"
 * - "Xtreme Gymnastics" vs "Xtreme AZ"
 */
export const AZ_TEAMS = [
  'AZ Olympians',
  'Aspire JrSunDevils',
  'Aspire AZ',  // USA meet variation
  'Biltmore',
  'Biltmore AZ',  // USA meet variation
  'Desert Thunder Gym',
  'Diamondbacks',
  'Flagstaff Gymnastics',
  'Flagstaff AZ',  // USA meet variation
  'Flex Gymnastics AZ',
  'GWC',
  'NVG',
  'Old Pueblo',
  'Old Pueblo AZ',  // USA meet variation
  'Rising Sky',
  'Rising Sky AZ',  // USA meet variation
  'SEGA',
  'SGA',
  'Synergy AZ',  // USA meet variation
  'SWGTC',
  'SWGTC AZ',  // USA meet variation
  'USAFlairs',
  'USAYFC AZ',  // Same as USAFlairs
  'Xtreme Gymnastics',
  'Xtreme AZ'  // USA meet variation
];

// Team name mappings for normalization
const TEAM_MAPPINGS = {
  'usayfc': 'usaflairs',  // USAYFC AZ -> USAFlairs
  'aspire': 'aspire',     // Aspire AZ, Aspire JrSunDevils -> both normalize to 'aspire'
};

/**
 * Normalize team name variations to a canonical form
 * @param {string} teamName - The team name to normalize
 * @returns {string} - Normalized canonical team name
 */
export const normalizeTeamForMatching = (teamName) => {
  if (!teamName) return '';

  // Remove " AZ" suffix and convert to lowercase
  let normalized = teamName.trim().replace(/\s+AZ$/i, '').toLowerCase();

  // Apply team-specific mappings
  for (const [key, canonical] of Object.entries(TEAM_MAPPINGS)) {
    if (normalized.includes(key)) {
      return canonical;
    }
  }

  return normalized;
};

/**
 * Check if a team is an Arizona team
 * @param {string} teamName - The team name to check
 * @returns {boolean} - True if the team is from Arizona
 */
export const isAzTeam = (teamName) => {
  if (!teamName) return false;

  // Normalize team name for comparison (trim whitespace, case-insensitive)
  const normalizedTeam = teamName.trim();

  return AZ_TEAMS.some(azTeam =>
    azTeam.toLowerCase() === normalizedTeam.toLowerCase()
  );
};
